import React, { useState } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import bootstrap from "@fullcalendar/bootstrap";
import timeGrid from "@fullcalendar/timegrid";
import calenderList from "@fullcalendar/list";
import interaction from "@fullcalendar/interaction";
import { FaCheck, FaDotCircle } from "react-icons/fa";
import { bgcolor, style } from "@mui/system";
import { Calender } from "../../components/Calender/Calender";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
const events = [
  // { title: 'Meeting', start: new Date() },
  // ,
  {
    // this object will be "parsed" into an Event Object
    title: "The Title", // a property!
    start: "2023-02-18", // a property!
    end: "2023-02-25",
    editable: true,
    durationEditable: true, // a property! ** see important note below about 'end' **
  },
];

export default () => {
  const keyss = [
    {
      img: "",
      value: "campaigns start",
    },
    {
      img: "",
      value: "campaigns End",
    },
    {
      img: "",
      value: "Install",
    },
    {
      img: "",
      value: "Removal",
    },
    {
      img: "",
      value: "Repair",
    },
    {
      img: "",
      value: "Photoshoot",
    },
    {
      img: "",
      value: "Swarm",
    },
    {
      img: "",
      value: "Special Event",
    },
    {
      img: "",
      value: "New Report",
    },
  ];
  const [data, setData] = useState();
  const [submitData, setSubmitData] = useState();
  function eventIcon(icon) {
    switch (icon) {
      case "Photoshoot":
        return (
          <img
            width="100%"
            src={require("../../assets/img/camera-icon.png")}
            alt=""
          />
        );
        break;
      case "campaigns start":
        return <FaDotCircle color="#00D030" />;
        break;
      case "campaigns End":
        return <FaDotCircle color="#F20000" />;
        break;
      case "Special Event":
        return (
          <i
            className="bi bi-balloon-heart-fill"
            style={{
              color: "black",
              fontSize: "22px",
              display: "flex",
              alignItems: "center",
            }}
          ></i>
        );
        break;
      case "Swarm":
        return (
          <img width="100%" src={require("../../assets/img/bee.png")} alt="" />
        );
        break;
      case "Repair":
        return (
          <img
            width="100%"
            src={require("../../assets/img/retargeting.png")}
            alt=""
          />
        );
        break;
      case "Removal":
        return (
          <img
            width="100%"
            src={require("../../assets/img/schedule-x-icon.PNG")}
            alt=""
          />
        );
        break;
      case "New Report":
        return (
          <img
            width="100%"
            src={require("../../assets/img/new-report.png")}
            alt=""
          />
        );
        break;
      case "Install":
        return (
          <img
            width="100%"
            src={require("../../assets/img/schedule-job-icon.png")}
            alt=""
          />
        );
        break;
      default:
        break;
    }
  }
  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };
  const currentDate = new Date();
  const options = {
    weekday: "long",
    month: "long",
    day: "numeric",
    suffix: "long",
  };
  const formattedDate = currentDate.toLocaleDateString("en-US", options);

  const displayDate = data?.date || formattedDate;
  function handleDateClick(date, events) {
    console.log({ date, events });
    setData({ date, events });
  }
  const handleEventsChange = async (events) => {
    const eventObjects = events.map((event) => ({
      color: event.color,
      date_time: event.date,
      title: event.title,
    }));
    setSubmitData({
      ...submitData,
      events: eventObjects,
    });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (submitData?.campaign_type) {
      apiClient.post("/advertiserSchedule", submitData);
    }
  };
  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="text-end mb-3">
          <div className="dropdown ">
            <button
              className="btn btn_bg shadow-none dropdown-toggle "
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Campaign
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "NetFlix")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    style={{ width: "100%" }}
                    src={require("../../assets/img/netflix-img.png")}
                    alt=""
                  />
                </div>
                <a
                  className="dropdown-item fw-bold"
                  style={{ color: "#005E9D" }}
                  href="#"
                >
                  -NetFlix
                </a>
              </li>
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    style={{ width: "100%" }}
                    src={require("../../assets/img/adidas-img.png")}
                    alt=""
                  />
                </div>
                <a
                  className="dropdown-item  fw-bold"
                  style={{ color: "#005E9D" }}
                  href="#"
                  onClick={() => handleChange("campaign_type", "Addidas")}
                >
                  -Addidas
                </a>
              </li>
              <li
                className="px-2 py-2"
                style={{ display: "flex", alignItems: "center" }}
                onClick={() => handleChange("campaign_type", "Disney")}
              >
                <div style={{ width: "4rem" }}>
                  <img
                    width={"100%"}
                    src={require("../../assets/img/disnep-img.png")}
                    alt=""
                  />
                </div>

                <a
                  className="dropdown-item fw-bold "
                  style={{ color: "#005E9D" }}
                  href="#"
                >
                  -Disney
                </a>
              </li>
            </ul>
          </div>
        </div>
        <Calender
          keyss={keyss}
          advertiser={"disable"}
          handleDateClick={handleDateClick}
        />

        <div className="row mt-2">
          <div className="col-md-8">
            <div className="border h-100 me-2 p-2 rounded-3">
              <h5 className="text_color  ">{displayDate}</h5>
              <hr className="hr_design mt-0" />
              {!(data?.events.length == 0) ? (
                <>
                  {data?.events?.map((event) => {
                    // let imageSrc = "";
                    // if (event.title === "Install") {
                    //   imageSrc = require("../../assets/img/schedule-job-icon.png");
                    // } else if (event.title === "Removal") {
                    //   imageSrc =require("../../assets/img/schedule-x-icon.PNG");
                    // }
                    // else if (event.title === "Repair") {
                    //   imageSrc = require("../../assets/img/retargeting.png");
                    // }
                    // else if (event.title === "Photoshoot") {
                    //   imageSrc = require("../../assets/img/camera-icon.png");
                    // }
                    // else if (event.title === "Swarm") {
                    //   imageSrc = require("../../assets/img/bee.png");
                    // }
                    // else if (event.title === "DroneShoot") {
                    //   imageSrc = require("../../assets/img/drone-dark.png");
                    // }
                    return (
                      <div className="d-flex gap-2 align-item-center flex-column flex-md-row">
                        <div style={{ width: "1rem" }}>
                          {eventIcon(event.title)}
                        </div>

                        <span>
                          - {event.title} at {event.time} <br />- Address:{" "}
                          {event.address}
                        </span>
                      </div>
                    );
                  })}
                </>
              ) : (
                "No Event"
              )}
              {/* <div className="d-flex gap-2 align-item-center flex-column flex-md-row mt-2">
              <div style={{ width: "1rem" }}>
                <img
                  width="100%"
                  src={require("../../assets/img/camera-icon.png")}
                  alt=""
                />
              </div>
              <span>
                - PhotoShoot in front of Moda Center after Swram at 5:30pm.{" "}
                <br />- Address: 321 Moda Rd., Portland, OR
              </span>
            </div> */}
            </div>
          </div>
          <div className="col-md-4 border p-2 rounded-3">
            <div className="d-flex align-item-center px-2">
              <div>
                <h5 className="text_color">Key</h5>
                <hr className="hr_design_2 mt-0" />
              </div>
              <div className="mt-3 ">
                <p className="text_color text_color d-flex align-items-center gap-1">
                  <FaDotCircle color="#00D030" />
                  campaigns start
                </p>

                <p className="text_color d-flex align-items-center gap-1">
                  <FaDotCircle color="#F20000" />
                  campaigns End
                </p>

                <p className=" text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/schedule-job-icon.png")}
                      alt=""
                    />
                  </div>
                  Install
                </p>

                <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/schedule-x-icon.PNG")}
                      alt=""
                    />
                  </div>
                  Removal
                </p>
                <p className="text_color text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/retargeting.png")}
                      alt=""
                    />
                  </div>
                  Retargeting
                </p>
                <p className="text_color text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/camera-icon.png")}
                      alt=""
                    />
                  </div>
                  Photoshoot
                </p>
                <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/bee.png")}
                      alt=""
                    />
                  </div>
                  Swarm
                </p>
                <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/brush.png")}
                      alt=""
                    />
                  </div>
                  Creative
                </p>
                <p className="text_color d-flex align-items-center gap-1">
                  <div style={{ width: "1rem" }}>
                    <img
                      width="100%"
                      src={require("../../assets/img/new-report.png")}
                      alt=""
                    />
                  </div>
                  New Report
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col text-center mt-5 save-main">
              <button type="submit" className="btn_bgnone btn blue-clr">
                <span className="pe-2">Save Changes</span>
                <FaCheck />
              </button>
            </div>
          </div>
        </div>
      </form>

      {/* <FullCalendar

        plugins={[dayGridPlugin,
          bootstrap,
          interaction,
          timeGrid,
          calenderList]}
        // headerToolbar={{
        //   start: 'title', // will normally be on the left. if RTL, will be on the right
        //   center: '',
        //   end: 'today prev,next' // will normally be on the right. if RTL, will be on the left
        // }}
        initialView='dayGridMonth'
      
        weekends={false}
        editable={true}
        selectable={true}
        durationEditable={true}
        events={events}
        headerToolbar={{
          left: "prev",
          center: "title",
          right: "next"
        }}
        height={500}
        
        // eventContent={renderEventContent}
      /> */}
    </div>
  );
};
